import { render, staticRenderFns } from "./CoinDisplay.vue?vue&type=template&id=427c3086&scoped=true"
import script from "./CoinDisplay.vue?vue&type=script&lang=js"
export * from "./CoinDisplay.vue?vue&type=script&lang=js"
import style0 from "./CoinDisplay.vue?vue&type=style&index=0&id=427c3086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427c3086",
  null
  
)

export default component.exports